// src/components/Spinner.jsx
function Spinner() {
  return <div className="spinner"></div>;
}

export { Spinner };
